import React, { useState, useEffect } from "react";
import logo from "../../assets/images/navbar/logo.png";
import connectIcon from "../../assets/images/navbar/connectIcon.png";
import Lines from "../../assets/images/navbar/Group1.png";
import Modale from "./modale";
import { RiSettingsFill, RiLuggageDepositFill } from "react-icons/ri";
import { MdGTranslate } from "react-icons/md";
import { HiUserCircle, CgMenuGridR, MdArrowDropDown } from "react-icons/all";
import { Link, useNavigate } from "react-router-dom";
import "./header.css";
import { useDispatch } from "react-redux";
import { logout, updateLogStatus } from "../../store/auth/auth";
import { BsList } from "react-icons/bs";
import { toast } from "react-toastify";
import { Button, Offcanvas, Overlay } from "react-bootstrap";
import Deposit_canva from "./deposit_canva";
import { updatePath } from "../../store/auth/auth";
import { updateTheme } from "../../store/spot";
function Navbar() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedIn = sessionStorage.getItem("isLoggedIn");
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    toast.success("Successfully Logout");
  };
  const [theme, setTheme] = useState<null | string>("");
  const toggleThem = () => {
    if (theme === "dark-theme") {
      dispatch(updateTheme('light'))
      localStorage.setItem("theme", "light-theme");
      setTheme("light-theme");
    } else {
      dispatch(updateTheme('dark'))
      

      setTheme("dark-theme");
      localStorage.setItem("theme", "dark-theme");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("theme") == null) {
      document.body.className = "dark-theme";
      localStorage.setItem("theme", "dark-theme");
      setTheme("dark-theme");
      dispatch(updateTheme('dark'))
    } else {
      document.body.className = localStorage.getItem("theme")!;
      setTheme(localStorage.getItem("theme"));
    }
  }, [theme]);
  const now = new Date();
  let Expire = now.getTime();
  let item = loggedIn && JSON.parse(loggedIn);

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-container p-0 header">
        <div className="container-fluid pos-sti p-0 me-2 me-lg-0">
          <Link
            className="navbar-brand p-0"
            to={"/"}
            onClick={() => dispatch(updatePath("/"))}
          >
            <img src={logo} alt="Virtual Exchange" className="img-fluid" />
          </Link>
          
         <ul className="m-0 p-0 me-auto">
         <li className="nav-item">
                <div className="dropdown_academy">
                  <div >
                    <Link
                      className="nav-link"
                      to="#"
                      style={{ fontSize: '20px'}}
                    >
                      <i> <CgMenuGridR /> </i>
                      <i className="head_drop_icon"> <MdArrowDropDown /> </i>
                    </Link>
                  </div>
                  <div className="dropdown-content">
                    <ul className="navbar-nav me-auto d-flex flex-column justify-content-center align-items-start">
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/news"
                          onClick={() => dispatch(updatePath("news"))}
                        >
                          Dao Network
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/learn"
                          onClick={() => dispatch(updatePath("learn"))}
                        >
                          Roadmap
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/data"
                          onClick={() => dispatch(updatePath("data"))}
                        >
                          Invite
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/withdraw"
                          onClick={() => dispatch(updatePath("withdraw"))}
                        >
                          Help Center
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/withdraw"
                          onClick={() => dispatch(updatePath("withdraw"))}
                        >
                          Task Center
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
         </ul> 

          <button
            className="navbar-toggler border-white"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <BsList className="text-white" />
          </button>
          <div
            className="collapse navbar-collapse collapsing_nav"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav m-0 ms-2 mb-2 mt-2 mb-lg-0 gap-2 gap-lg-1 gap-xl-2">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/buycoin"
                  onClick={() => dispatch(updatePath("buycoin"))}
                >
                  Buy Coins
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/market"
                  onClick={() => dispatch(updatePath("market"))}
                >
                  Market
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/spot"
                  onClick={() => dispatch(updatePath("spot"))}
                >
                  Spot
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/virtualstart"
                  onClick={() => dispatch(updatePath("virtualstart"))}
                >
                  Virtual Startup
                </Link>
              </li>
              <li className="nav-item">
                <div className="dropdown_academy">
                  <div tabIndex={0}>
                    <Link
                      className="nav-link"
                      to="#"
                      onClick={() => dispatch(updatePath("academy"))}
                    >
                      Academy
                    </Link>
                  </div>
                  <div className="dropdown-content">
                    <ul className="navbar-nav me-auto d-flex flex-column justify-content-center align-items-start">
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/news"
                          onClick={() => dispatch(updatePath("news"))}
                        >
                          News
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/learn"
                          onClick={() => dispatch(updatePath("learn"))}
                        >
                          Learn
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/data"
                          onClick={() => dispatch(updatePath("data"))}
                        >
                          Data
                        </Link>
                      </li>
                      {/* Dummy Withdraw Section */}
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/withdraw"
                          onClick={() => dispatch(updatePath("withdraw"))}
                        >
                          Withdraw
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <div className="dropdown">
                <div tabIndex={0}>
                  <Link className="nav-link" to="">
                    <img
                      src={Lines}
                      width={"20px"}
                      className="img-fluid"
                      alt=""
                      onClick={() => dispatch(updatePath("daoparent"))}
                    />
                  </Link>
                </div>
                <div className="dropdown-content">
                  <ul className="navbar-nav me-auto d-flex flex-column justify-content-center align-items-start">
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        aria-current="page"
                        to="/dao"
                        onClick={() => dispatch(updatePath("dao"))}
                      >
                        Dao
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        aria-current="page"
                        to="/invite"
                        onClick={() => dispatch(updatePath("invite"))}
                      >
                        Invite
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        aria-current="page"
                        to="/roadmap"
                        onClick={() => dispatch(updatePath("roadmap"))}
                      >
                        Roadmap
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        aria-current="page"
                        to="/helpcenter"
                        onClick={() => dispatch(updatePath("helpcenter"))}
                      >
                        Help Center
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link "
                        aria-current="page"
                        to="/lottery"
                        onClick={() => dispatch(updatePath("lottery"))}
                      >
                        Lottery
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </ul>

            <div className="d-flex gap-2 gap-lg-1 gap-xl-3 ms-auto nav_last_btns">
            {item && item.expiry > Date.now() ? (
                <div className="dropdown">
                  <button className="bg-transparent border-0 outline-0">
                    <HiUserCircle className="user-icon" />
                  </button>
                  <div className="dropdown-content-ldmode">
                    <div>
                      <button
                        className="btn-Login"
                        onClick={() => {
                          handleLogout();
                          dispatch(updatePath("login"));
                        }}
                      >
                        Logout
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <button
                  className="btn-Login"
                  onClick={() => {
                    navigate("/login");
                    dispatch(updatePath("login"));

                    // toast.error("Please login");
                  }}
                >
                  Login
                </button>
              )}
              {/* Deposit Button */}
              {loggedIn ? (
                <>
                  <Deposit_canva />
                </>
              ) : (
                <>
                  <button
                    className="btn-Register ms-md-1 ms-lg-0"
                    onClick={() => {
                      navigate("/register");
                      dispatch(updatePath("register"));
                    }}
                  >
                    Register
                  </button>
                  <button
                    className="btn_connect_bg ms-md-1 ms-lg-0"
                    onClick={() => handleShow()}
                  >
                    {/* <div className="btn_connect_icon_bg p-2">
                      <img
                        src={connectIcon}
                        className="img-fluid btn_connect_icon_bg"
                        alt=""
                      />
                    </div> */}
                    <div className="btn_connection_wallet">Connect Wallet</div>
                  </button>
                </>
              )}
              {/* Settings Button */}
              <div className="dropdown">
                <button className="bg-transparent border-0 outline-0">
                  <RiSettingsFill className="settings-icon" />
                </button>
                <div className="dropdown-content-ldmode">
                  <div className=" my-2 ">
                    <Link
                      className="nav-link"
                      aria-current="page"
                      to="/settings/twofa"
                      onClick={() => dispatch(updatePath("setting"))}
                    >
                      Twofactor
                    </Link>
                  </div>
                </div>
              </div>

              {/* Google Translate Button */}
              <button className="bg-transparent border-0 outline-0">
                <MdGTranslate className="settings-icon" />
              </button>

              <div className="form-check form-switch switch ms-md-1 ms-lg-0">
                    <input
                      className="form-check-input change light_mode mt-2"
                      onClick={() => toggleThem()}
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                    />
                  </div>
            </div>
          </div>
        </div>
      </nav>
      {show && <Modale show={show} handleClose={handleClose} />}
    </>
  );
}

export default Navbar;
